export const unattendedResult = {
  PENDING: 1,
  RUNNING_NO_ERRORS: 2,
  ENDED_NO_ERRORS: 3,
  ENDED_WITH_ERRORS: 4,
  RUNNING_WHIT_ERRORS: 5
}
